import styles from '../css/loginPage.module.scss';
import globalPageStyle from '../css/globalPage.module.scss';
import { useAuth } from '../context/AuthContext';
import { useEffect, useState } from 'react';
import CustomTextInput from '../components/customTextInput';
import { useTranslation } from 'react-i18next';

const LoginPage = () => {
  const { login, user } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { t } = useTranslation();

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await login(email, password);
  };

  useEffect(() => {
    if (user) {
      window.location.replace('/');
    }
  }, [user]);

  return (
    <main className={globalPageStyle.pageContainer}>
      <div className={globalPageStyle.pageContent}>
        <h1>{t('sidebar.login')}</h1>
        <form onSubmit={handleLogin} className={styles.loginForm}>
          <div className={styles.inputContainer}>
            <label htmlFor="email">{t('sidebar.email')}</label>
            <CustomTextInput type="email" id="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>

          <div className={styles.inputContainer}>
            <label htmlFor="password">{t('sidebar.password')}</label>
            <CustomTextInput type="password" id="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>

          <button type="submit" className="primaryButton">
            {t('sidebar.login')}
          </button>
        </form>
      </div>
    </main>
  );
};

export default LoginPage;
